import { Button, Grid, Paper } from "@material-ui/core";
import { formTypeLabels, questionTypes } from "features/Forms/formBuilder/formBuilderConsts";
import FormFailure from "../FormFailure";
import { Question } from "./components/Question";
import { EditFormOutputStyle } from "./style";

export const EditFormOutputFields = ({
    customFormResponse,
    allQuestions,
    formAnswers,
    setFormAnswers,
    formType,
    showFailuresOnly,
    setShowFailuresOnly,
    getIsFailure,
    handleSave,
    isSaving,
    resetForm
}) => {
    const classes = EditFormOutputStyle();

    const isQuestionValid = (q) => {
        switch (q?.questionType) {
            case questionTypes.Image:
                return (formAnswers?.[q.id]?.pictureObj || formAnswers?.[q.id]?.pictureUrl) ? true : false;
            case questionTypes.MultipleChoice:
                return (formAnswers?.[q.id]?.multipleChoiceValue && formAnswers?.[q.id]?.multipleChoiceValue != "[]") ? true : false;
            case questionTypes.Freetext:
                return (formAnswers?.[q.id]?.freetextValue && formAnswers?.[q.id]?.freetextValue != `""`) ? true : false;
            case questionTypes.Date:
                return (formAnswers?.[q.id]?.dateValue && formAnswers?.[q.id]?.dateValue != `""`) ? true : false;
            case questionTypes.Dropdown:
                return (formAnswers?.[q.id]?.dropdownValue && formAnswers?.[q.id]?.dropdownValue != `""`) ? true : false;
            default:
                return (formAnswers?.[q.id]?.values && formAnswers?.[q.id]?.values != `""`) ? true : false
        }
    }

    const isValid = () => {
        return allQuestions?.every(q => !q.required || isQuestionValid(q))
    }

    return (
        <>
            <Paper variant='outlined' className={classes.reportContainer}>
                <Grid container alignItems='center' justifyContent="space-between" style={{ padding: '1em', background: '#efefef' }}>
                    <Grid item>
                        <div>{`Edit ${formTypeLabels[formType]}`}</div>
                    </Grid>
                    <Grid item>
                        <FormFailure customFormResponse={customFormResponse} showFailuresOnly={showFailuresOnly} setShowFailuresOnly={setShowFailuresOnly} />
                    </Grid>
                </Grid>
                <form id="editFormOutput" className={`${classes.form}`}>
                    {allQuestions?.map((q, index) => <>
                        <Question
                            key={q.id}
                            question={q}
                            formAnswers={formAnswers}
                            setFormAnswers={setFormAnswers}
                            showFailuresOnly={showFailuresOnly}
                            getIsFailure={getIsFailure}
                        />
                    </>)}
                </form>
                <Paper className={classes.reportActions} >
                    <Grid container justifyContent="flex-end" spacing={2}>
                        <Grid item>
                            <Button onClick={() => resetForm()} variant="outlined" color="primary" disabled={isSaving}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                onClick={handleSave}
                                color="primary"
                                variant="contained"
                                disabled={isSaving || !isValid()}
                            >
                                {isSaving ? 'Saving...' : 'Save'}
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Paper>
        </>
    )
}